import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'cl-common-angular';
import { DonorGuard } from './core/donor-guard.service';
import { SchoolGuard } from './core/school-guard.service';
import { StudentGuard } from './core/student-guard.service';

const routes: Routes = [
    { path: 'school', loadChildren: () => import('./school/school.module').then(m => m.SchoolModule), canActivate: [SchoolGuard], canActivateChild: [SchoolGuard], canLoad: [AuthGuard] },
    { path: 'student', loadChildren: () => import('./student/student.module').then(m => m.StudentModule), canActivate: [StudentGuard], canActivateChild: [StudentGuard], canLoad: [AuthGuard] },
    { path: 'donor', loadChildren: () => import('./donor/donor.module').then(m => m.DonorModule), canActivate: [DonorGuard], canActivateChild: [DonorGuard], canLoad: [AuthGuard] },
    { path: 'public', loadChildren: () => import('./public/public.module').then(m => m.PublicModule) },
    { path: 'createaccount', loadChildren: () => import('./create-account/create-account.module').then(m => m.CreateAccountModule) },
    { path: 'createdonoraccount', loadChildren: () => import('./create-donor-account/create-donor-account.module').then(m => m.CreateDonorAccountModule) },
    { path: 'createexternalrevieweraccount', loadChildren: () => import('./create-external-reviewer-account/create-external-reviewer-account.module').then(m => m.CreateExternalReviewerAccountModule) },
    { path: 'recommendation', loadChildren: () => import('./recommendation/recommendation.module').then(m => m.RecommendationModule) },
    { path: '', pathMatch: 'full', redirectTo: 'school' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
